<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Admin Users</h1>
          <div class="custom_toolbar">
            <input
              type="text"
              placeholder="Search..."
              class="c-input"
              v-model="params.q"
              v-on:keyup="search"
            />
            <el-button
              style="margin-left: 20px"
              type="success"
              round
              icon="el-icon-plus"
              @click="createNew"
              >Create New</el-button
            >
          </div>
        </div>
      </div>
      <div class="row u-mt-medium">
        <div class="col-12">
          <vue-good-table
            v-loading="loading"
            mode="remote"
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            @on-page-change="onPageChange"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <!-- <span v-if="props.column.field == 'name'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        {{props.row.name.toUpperCase()}}<br/>
                                        <el-tag size="mini" type="info">@{{props.row.username}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span> -->
              <span v-if="props.column.field == 'name'">
                <el-row type="flex" justify="center">
                  <el-col :span="4">
                    <el-image
                      style="width: 40px; height: 40px; border-radius: 50%"
                      fit="cover"
                      :src="'https://api.bniservicerating.com'+props.row.avatar"
                    >
                    </el-image>
                  </el-col>
                  <el-col :span="20">
                    {{ props.row.name.toUpperCase() }}<br />
                    <el-tag size="mini" type="success">{{ props.row.username }}</el-tag>
                  </el-col>
                </el-row>
              </span>
              <span v-else-if="props.column.field == 'user_role_name'">
                <el-tag
                  size="mini"
                  :type="
                    props.row.user_role_id == 1
                      ? 'success'
                      : props.row.user_role_id == 2
                      ? 'warning'
                      : 'info'
                  "
                  >{{ props.row.user_role_name }}</el-tag
                >
              </span>
              <span v-else-if="props.column.field == 'status'">
                <el-switch
                  :disabled="props.row.id == user_id || props.row.id == 1"
                  active-color="#13ce66"
                  inactive-color="#edf1f7"
                  :value="props.row.status == 1 ? true : false"
                  @change="switchChanged(props.row.originalIndex)"
                ></el-switch>
              </span>
              <span v-else-if="props.column.field == 'action'">
                <el-button
                  v-if="props.row.id != user_id || props.row.id != 1"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="editUser(props.row.originalIndex)"
                ></el-button>
                <el-button
                  v-if="props.row.id != user_id || props.row.id != 1"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="showAlertDelete(props.row.id)"
                  circle
                ></el-button>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <el-dialog
      :title="formType == 'edit' ? 'Edit User' : 'Add User'"
      :visible.sync="dialogFormVisible"
      width="40%"
    >
      <el-form :model="form">
        <el-form-item label="Username">
          <el-input
            v-model="form.username"
            :disabled="formType == 'edit'"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Password" v-show="formType == 'add'">
          <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Status">
          <el-switch
            active-color="#13ce66"
            inactive-color="#edf1f7"
            v-model="form.status"
          ></el-switch>
        </el-form-item>
        <el-form-item label="Role">
          <div style="margin: 40px 0 0"></div>
          <el-select v-model="form.user_role_id" placeholder="Select" style="width: 100%">
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Kode Wilayah" v-show="form.user_role_id == 2">
          <el-input v-model="form.relation_code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Kode Outlet" v-show="form.user_role_id == 3">
          <el-input v-model="form.relation_code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveUser()" :loading="loading2"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import api from "@/api/admin";
export default {
  name: "admins",
  components: {
    "vue-good-table": VueGoodTable,
  },
  data() {
    return {
      dialogFormVisible: false,
      form: {
        id: "",
        username: "",
        name: "",
        password: "",
        status: 0,
        user_role_id: "",
        relation_code: "",
      },
      roles: [
        { id: 1, name: "Admin" },
        { id: 2, name: "Admin Wilayah" },
        { id: 3, name: "Admin Outlet" },
      ],
      columns: [
        {
          label: "User",
          field: "name",
        },
        {
          label: "Role",
          field: "user_role_name",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          width: "150px",
        },
        {
          label: "Status",
          field: "status",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          width: "100px",
        },
        {
          label: "Action",
          field: "action",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          width: "100px",
        },
      ],
      rows: [],
      totalRecords: 0,
      page: 1,
      params: {
        q: "",
      },
      loading: false,
      loading2: false,
      user_id: localStorage.getItem("id"),
      formType: "edit",
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions(["logout"]),
    fetch() {
      this.loading = true;
      var self = this;
      api
        .getUsers(this.page, this.params.q)
        .then(function (response) {
          self.rows = response.data.data;
          self.totalRecords = response.data.meta.totalRecords;
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    onPageChange(params) {
      console.log(params);
      this.page = params.currentPage;
      this.fetch();
    },
    search() {
      this.fetch();
    },
    switchChanged(id) {
      console.log(id);
      console.log(this.rows[id]);
      var self = this;
      api
        .updateUser(this.rows[id].id, { status: !this.rows[id].status })
        .then(function (response) {
          self.fetch();
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading2 = false;
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    editUser(id) {
      this.formType = "edit";
      // console.log(id)
      this.form = {
        id: this.rows[id].id,
        name: this.rows[id].name,
        username: this.rows[id].username,
        status: this.rows[id].status == 1 ? true : false,
        user_role_id: this.rows[id].user_role_id,
        relation_code: this.rows[id].relation_code,
      };
      this.dialogFormVisible = true;
    },
    saveUser() {
      if (this.formType == "add") {
        this.addUser();
      } else {
        var params = {
          name: this.form.name,
          user_role_id: this.form.user_role_id,
          relation_code: this.form.relation_code,
          status: this.form.status,
        };
        this.loading2 = true;
        var self = this;
        api
          .updateUser(this.form.id, params)
          .then(function (response) {
            self.loading2 = false;
            self.dialogFormVisible = false;
            self.fetch();
            self.$message({
              type: "success",
              message: response.data.message,
            });
          })
          .catch(function (error) {
            self.loading2 = false;
            console.log(error);
            self.$message({
              type: "danger",
              message: error.response.data.message,
            });
            if (error.response.status == 403) {
              self.logout();
            }
          });
      }
    },
    showAlertDelete(id) {
      this.$confirm("This will permanently delete the data. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.deleteUser(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    deleteUser(id) {
      var self = this;
      api
        .deleteUser(id)
        .then(function (response) {
          self.$message({
            type: "success",
            message: response.data.message,
          });
          self.fetch();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    createNew() {
      this.formType = "add";
      this.form = {
        id: "",
        name: "",
        username: "",
        password: "",
        status: 1,
        user_role_id: 1,
        relation_code: null,
      };
      this.dialogFormVisible = true;
    },
    addUser() {
      var params = {
        name: this.form.name,
        username: this.form.username,
        password: this.form.password,
        user_role_id: this.form.user_role_id,
        status: this.form.status,
        relation_code: this.form.relation_code,
      };
      this.loading2 = true;
      var self = this;
      api
        .createUser(params)
        .then(function (response) {
          self.loading2 = false;
          self.dialogFormVisible = false;
          self.fetch();
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading2 = false;
          console.log(error);
          self.$message({
            type: "danger",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
.el-row--flex.is-justify-center {
  align-items: center !important;
}
</style>
